/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { makeTree, DEFAULT_SAVED_SEARCH_TREE_SORT } from '../helpers/savedSearches';

export const addSavedSearch = createAsyncThunk(
  'savedSearches/add',
  async (
    {
      name, data, shared, path, showToast = true,
    },
    {
      extra: {
        sdk, Logger, Toast, localization: l18n, showErrorDialog, utils,
      },
      getState,
    },
  ) => {
    try {
      const { data: newItem } = await sdk.savedSearches.create(name, data, shared, path);
      if (showToast) {
        Toast(l18n.TAGSTREE.alertSearchAdded(name), { type: 'success' });
      }
      newItem.nodes = [];

      return { newItem, userId: getState().user._id };
    } catch (error) {
      const errorStatus = utils.getStatusFromResponceError(error);
      if (errorStatus === 403) {
        showErrorDialog(l18n.NO_PERMISSION_TO_ACCESS);
      } else if (errorStatus === 409) {
        Toast(l18n.SAVEDSEARCHESTREE.textDuplicateSavedSearchInLocation, { type: 'error' });
      } else {
        Logger.error(new Error('Can not add saved searches'), { error }, [
          'AddSavedSearchesFailed',
          { errorMessage: (error && error.message) || 'NoMessage' },
        ]);
      }

      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder.addCase(
    addSavedSearch.pending,
    (state) => {
      state.isAdding = true;
    },
  ).addCase(
    addSavedSearch.fulfilled,
    (state, { payload: { newItem, userId } }) => {
      state.isAdding = false;
      state.all.push(newItem);
      // When the new search is grouped (`path` set), naive push into the
      // appropriate root array would render it twice — once at the root and
      // once inside its virtual group. Re-deriving the tree via makeTree keeps
      // ungrouped, grouped, and placeholder cases consistent.
      if (newItem.path) {
        state.tree = makeTree(
          state.all,
          userId,
          state.searchQuery,
          state.treeSortType || DEFAULT_SAVED_SEARCH_TREE_SORT,
        );
      } else if (newItem.teamId) {
        state.tree.teamSearches.nodes.push(newItem);
      } else {
        state.tree.personalSearches.nodes.push(newItem);
      }
    },
  ).addCase(
    addSavedSearch.rejected,
    (state, { error }) => {
      state.isAdding = false;
      state.error = error;
    },
  );
};
